import "./input.scss";
import type { FC, InputHTMLAttributes, ReactNode } from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import FontAwesomeLight from "../../../app/Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    icon: IconProp;
    label: string;
    showLabel?: boolean;
    onClear?: () => void;
    hint?: ReactNode;
}

const Input: FC<Props> = ({ icon, label, showLabel = true, onClear, hint, ...props }) => (
    <label className="block">
        {showLabel && label}
        {hint && (
            <p className="text-xs text-[var(--color-text-tertiary)] mt-1 mb-2">
                {hint}
            </p>
        )}
        <div className="form-input">
            <div className="input-icon left">
                <FontAwesomeLight icon={icon} />
            </div>
            <input
                placeholder={label}
                {...props}
            />
            {(typeof onClear === "function" && !!props.value) && (
                <div
                    className="input-icon right clickable"
                    onClick={onClear}
                >
                    <FontAwesomeLight icon="times" />
                </div>
            )}
        </div>
    </label>
);

export default Input;
